import { useState, useEffect } from "react";
import "./App.css";
import searchIcon from "./search.svg";
import MovieCard from "./MovieCard";
import EmptyHome from "./EmptyHome";
import LoadingAnimation from "./LoadingAnimation";
import 'font-awesome/css/font-awesome.min.css';
const API_URL = "https://omdbapi.com?apikey=c9145752";

//
const App = () => {
  const [movies, setMovies] = useState([]);
  const [searchTerm, setsearchTerm] = useState("");
  const [emptyhome,setEmptyhome] = useState(false);
  const [loading,setLoading] = useState(false);
  useEffect(() => {
     setEmptyhome(true)
  }, []);

  const searchMovies = async (title) => {
    const trimmedTitle = title.trim();
    if(trimmedTitle === '') {
        setEmptyhome(true)
        alert(" Please Enter Movie Name !!")
        return;
    }
    setEmptyhome (false);
    setLoading(true);
    try{
    const response = await fetch(`${API_URL}&s=${trimmedTitle}`);
    const data = await response.json();
    data.Search ? setMovies(data.Search) : setMovies([]);
    }
    catch(error){
        console.log("Unable to fetch data" , error);
        setMovies([]);
    } finally{
        setLoading(false);
    }
    // console.log(movies)
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      searchMovies(searchTerm);
    }
  };
  return (
    <div className="app">
      <div className="linktree-icon">
        <a href="https://linktr.ee/_soumya" target="blank" >
        <i className="fa fa-globe" aria-hidden="true"></i>
        </a>
      </div>
      <h1>Beyond Movies</h1>
      <div className="search">
        <input
          value={searchTerm}
          onChange={(e) => setsearchTerm(e.target.value)}
          onKeyDown={handleKeyPress} 
          placeholder="Search for movies"
        />
        <img
          src={searchIcon}
          alt="search"
          onClick={() => searchMovies(searchTerm)}
        />
      </div>
      {emptyhome ? (<EmptyHome/>):( loading? (<LoadingAnimation/>) :
      movies?.length > 0 ? (
        <div className="container">
          {movies.map((movie) => (
            <MovieCard movie={movie} />
          ))}
        </div>
      ) : (
        <div className="empty">
          <h2>No movies found</h2>
        </div>
      ))}
    </div>
  );
};

export default App;